module.exports = __webpack_public_path__ + "dcd0f0acd39cf7fd8d4e995fb52b434a.svg";